module.exports = __webpack_public_path__ + "img/nav_icon_vip@2x.2682a506.png";